<template>
  <div class="header">
    <router-link :to="backLink" class="btn backlink" v-if="backLink">←</router-link>
    <h1 class="title">{{ title ? title : 'Emma' }}</h1>
  </div>
</template>

<script>
export default {
  props: ['backLink', 'title']
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables';

.header {
  padding: calc(env(safe-area-inset-top) + 1rem) calc(env(safe-area-inset-right) + 1rem) 1rem
    calc(env(safe-area-inset-left) + 1rem);

  background: $main;

  color: #fff;
}
.backlink {
  position: absolute;
  width: 2rem;
  height: 2rem;
  padding: 0;

  border-color: #ccc;

  color: #fff;
  font-size: 16px;
  line-height: 2rem;
  text-align: center;
}

.title {
  width: 100%;

  font-size: 1.5rem;
  text-align: center;
}
</style>
